<template>
    <div class="container">
        <md-dialog :md-active.sync="modalEditar" :md-click-outside-to-close="false">
            <md-dialog-title class="text-center">
                {{ labels.title }} {{ infoFinanciera.vigencia.slice(0,7) }}
            </md-dialog-title>
            <md-dialog-content>
                <b-row class="text-left">
                    <b-col cols="2.4">
                        <md-button @click="constantes" class="md-dense md-raised md-primary btn-info">{{ labels.constantes }}</md-button>
                    </b-col>
                    <b-col cols="2.4">
                        <md-button @click="editarInfoFinanciera" class="md-dense md-raised md-primary btn-info">{{ labels.editar }}</md-button>
                    </b-col>
                    <b-col cols="2.4">
                        <md-button @click="cifrasInfoFinanciera" class="md-dense md-raised md-primary btn-info">{{ labels.cifras }}</md-button>
                    </b-col>
                    <b-col cols="2.4">
                        <md-button @click="clasificacion" class="md-dense md-raised md-primary btn-info">{{ labels.clasificacion }}</md-button>
                    </b-col>
                    <b-col cols="2.4">
                        <md-button @click="calificacionTasas" class="md-dense md-raised md-primary btn-info">{{ labels.tasas }}</md-button>
                    </b-col>
                </b-row>
                <div v-if="showEditar" class="mt-2">
                    <Modificar :infoFinanciera="infoFinanciera"></Modificar>
                </div>
                <div v-if="showCifras" class="mt-2">
                    <Cifras :infoFinanciera="infoFinanciera" :infoConstante="infoConstante" :saveScore="showCifras"></Cifras>
                </div>
                <div v-if="showClasificacion" class="mt-2">
                    <Clasificacion :infoVigencia="infoFinanciera.vigencia"></Clasificacion>
                </div>
                <div v-if="showTasas" class="mt-2">
                    <Tasas :infoVigencia="infoFinanciera.vigencia"></Tasas>
                </div>
                <div v-if="showConstantes" class="mt-2">
                    <Constantes :infoVigencia="infoFinanciera.vigencia"></Constantes>
                </div>
                <md-dialog-actions class="mt-1">
                    <!-- <md-button class="md-primary" @click="guardarZscore">{{ labels.save }}</md-button> -->
                    <md-button class="md-accent" @click="cierraModal">{{ labels.close }}</md-button>
                </md-dialog-actions>
            </md-dialog-content>
        </md-dialog>
    </div>
</template>

<script>
import InformacionFinanciera from '../../../services/InformacionFinanciera'
import Cifras from './Cifras.vue';
import Modificar from './Modificar.vue';
import Clasificacion from './Clasificacion.vue';
import Tasas from './Tasas.vue';
import Constantes from './Constantes.vue';

export default {
    name : 'Detalle',
    props : ['modalEditar','infoFinanciera','infoConstante'],
    components : {
        Cifras,
        Modificar,
        Clasificacion,
        Tasas,
        Constantes,
    },
    data : () => ({
        showEditar : false,
        showCifras : false,
        showClasificacion : false,
        showTasas : false,
        showConstantes : false,
    }),
    computed:{
        labels(){
            if (this.$store.state._language == "es-ES") {
                return {
                    title : 'Zscore',
                    save : 'Guardar',
                    close : 'Cerrar',
                    constantes : 'Constantes',
                    editar : 'Financiera',
                    cifras : 'Score',
                    clasificacion : 'Variables',
                    tasas : 'Tasas'
                }
            }else{
                return {
                    title : 'Zscore',
                    save : 'Save',
                    close : 'Close',
                    constantes : 'Constants',
                    editar : 'Finantial information',
                    cifras : 'Score',
                    clasificacion : 'Classification',
                    tasas : 'Rates'
                }
            }
        }
    },
    methods:{
        cierraModal(){
            this.$emit('cierraModal',false)

            this.showConstantes = false
            this.showEditar = false
            this.showCifras = false
            this.showClasificacion = false
            this.showTasas = false
        },
        constantes(){
            this.showConstantes = true

            this.showEditar = false
            this.showCifras = false
            this.showClasificacion = false
            this.showTasas = false
        },
        editarInfoFinanciera(){
            this.showEditar = true

            this.showCifras = false
            this.showClasificacion = false
            this.showTasas = false
            this.showConstantes = false
        },
        cifrasInfoFinanciera(){
            this.showCifras = true

            this.showEditar = false
            this.showClasificacion = false
            this.showTasas = false
            this.showConstantes = false
        },
        clasificacion(){
            this.showClasificacion = true

            this.showEditar = false
            this.showCifras = false
            this.showTasas = false
            this.showConstantes = false
        },
        calificacionTasas(){
            this.showTasas = true

            this.showEditar = false
            this.showCifras = false
            this.showClasificacion = false
            this.showConstantes = false
        },
        guardarZscore(){
            const dataForm = [
                this.infoFinanciera.vigencia,
                this.infoFinanciera.activo_corriente,
                this.infoFinanciera.activo_no_corriente,
                this.infoFinanciera.total_activo,
                this.infoFinanciera.pasivo_corriente,
                this.infoFinanciera.pasivo_no_corriente,
                this.infoFinanciera.total_pasivo,
                this.infoFinanciera.utilidad_acumulada,
                this.infoFinanciera.total_patrimonio,
                this.infoFinanciera.ebit,
            ]

            if(dataForm.includes('')){
                this.$toast.error('Campo(s) pendiente(s) por diligenciar')
            
            }else{

                let info = {
                    'id' : this.infoFinanciera.id,
                    'vigencia' : this.infoFinanciera.vigencia,
                    'activoCorriente' :this.infoFinanciera.activo_corriente,
                    'activoNoCorriente' : this.infoFinanciera.activo_no_corriente,
                    'totalActivo' : this.infoFinanciera.total_activo,
                    'pasivoCorriente' : this.infoFinanciera.pasivo_corriente,
                    'pasivoNoCorriente' : this.infoFinanciera.pasivo_no_corriente,
                    'totalPasivo' : this.infoFinanciera.total_pasivo,
                    'utilidadAcumulada' : this.infoFinanciera.utilidad_acumulada,
                    'totalPatrimonio' : this.infoFinanciera.total_patrimonio,
                    'ebit' : this.infoFinanciera.ebit,
                    'idUser' : this.$store.state.userId
                }
                // console.log(info);

                InformacionFinanciera.updateInformacionFinanciera(info)
                .then((res) => {
                    if(res.status == 200){
                        this.$toast.success(res.data.message)
                        location. reload()                    
                    }
                })
                .catch((err) => console.log(err))
            }
        }
    }
}
</script>

<style>

</style>
